<template>
  <div class="account-sidebar">
    <div class="sidebar-nav">
      <div v-for="item in menuItems" :key="item.id" class="sidebar-item" :class="{
        'active': isItemActive(item),
        'has-sidebar-dropdown': item.children
      }">
        <div class="sidebar-item-header" @click="item.children ? toggleDropdown(item.id) : selectTab(item.type, item)">
          <span class="sidebar-label">{{ item.label }}</span>
          <span v-if="item.children" class="sidebar-dropdown-arrow" :class="{ 'open': shouldShowDropdown(item) }">
            <img src="@/assets/icons/arrow_down_black.svg" alt="arrow" />
          </span>
        </div>
        <div v-if="item.children && shouldShowDropdown(item) && item.isShown" class="sidebar-dropdown-menu">
          <div v-for="child in item.children" :key="child.id" class="sidebar-dropdown-item"
            :class="{ 'active': switch_tab === child.type }" @click="selectTab(child.type, item)">
            <span class="sidebar-label">{{ child.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "account-sidebar",
  components: {},
  props: {
    switch_tab: {
      type: String,
      default: "",
    },
    account: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      openDropdowns: [],
      menuItems: [
        { id: 1, type: 'overview', label: 'Overview', isShown: false },
        // { id: 2, type: 'projects', label: 'Projects' },
        {
          id: 3,
          type: 'contacts',
          label: 'Contacts',
          isShown: false,
          children: [
            { id: 31, type: 'account-contact', label: 'Account Contact' },
            { id: 32, type: 'lia-generation', label: 'Lia Generation' }
          ]
        },
        { id: 4, type: 'tasks', label: 'Tasks Planner', isShown: false },
        { id: 5, type: 'leads', label: 'Leads', isShown: false },
        { id: 6, type: 'attachments', label: 'Attachments', isShown: false },
        // { id: 7, type: 'notes', label: 'Notes', isShown: false },
        { id: 8, type: 'activities', label: 'Activities', isShown: false }
      ]
    };
  },
  created() {
    // Initialize dropdowns based on active tab
    this.initializeDropdowns();
  },
  methods: {
    initializeDropdowns() {
      const activeParent = this.menuItems.find(item =>
        item.children?.some(child => child.type === this.switch_tab)
      );
      if (activeParent && !this.openDropdowns.includes(activeParent.id)) {
        this.openDropdowns.push(activeParent.id);
      }
    },
    isItemActive(item) {
      if (item.type === this.switch_tab) return true;
      return item.children?.some(child => child.type === this.switch_tab) || false;
    },
    shouldShowDropdown(item) {
      return this.openDropdowns.includes(item.id) || this.isItemActive(item);
    },
    toggleDropdown(itemId) {
      const index = this.openDropdowns.indexOf(itemId);
      const item = this.menuItems.find(i => i.id === itemId);

      if (index === -1) {
        this.openDropdowns.push(itemId);
      } else if (!this.isItemActive(item)) {
        this.openDropdowns.splice(index, 1);
      }
      item.isShown = !item.isShown;
    },
    selectTab(type, item) {
      let vm = this;

      let path = [
        {
          label: "Accounts",
          path: "/accounts/list",
        }
      ];


      // Add account name at the end
      if (vm.account.name) {
        path.push({
          label: vm.account.name,
          active: true,
        });
      }

      vm.$store.commit("SET_PATH", path);
      item.isShown = false;
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => { });


    },
  },
  watch: {
    switch_tab: {
      handler(newVal) {
        this.initializeDropdowns();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.account-sidebar {
  display: flex;
  flex-direction: row;
  height: max-content;


  .sidebar-nav {
    display: flex;
    flex-direction: row;
    gap: 10px;

    .sidebar-item {
      cursor: pointer;
      position: relative;

      .sidebar-item-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
      }

      @media (min-width: 300px) and (max-width: 630px) {
        font-size: 11px;
      }

      .sidebar-label {
        display: block;
        color: #707070;

        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
      }

      .sidebar-dropdown-arrow {
        display: flex;
        align-items: center;
        transition: transform 0.3s ease;
        margin-left: 8px;

        img {
          width: 12px;
          height: 12px;
        }

        &.open {
          transform: rotate(-180deg);
        }
      }

      .sidebar-dropdown-menu {
        background: #fff;
        position: absolute;
        top: 100%;
        left: 0;
        min-width: 100%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        z-index: 1000;

        .sidebar-dropdown-item {
          height: 35px;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          white-space: nowrap;
          transition: all 0.3s ease;

          &:hover {
            background-color: #f5f5f5;

            .sidebar-label {
              color: #1ba5a4;
            }
          }

          &.active {
            .sidebar-label {
              color: #1ba5a4 !important;
              font-weight: 500;
            }
          }

          .sidebar-label {
            display: block !important;
            font-size: 0.9em;
            transition: color 0.3s ease;

            @media (min-width: 300px) and (max-width: 630px) {
              display: block !important;
            }
          }
        }
      }

      &.active {
        >.sidebar-item-header {
          .sidebar-label {
            color: #1ba5a4;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
